import React, { useState } from 'react';
import { Relative } from '../Relative/Relative';
import { BackgroundAnimation, CloseIcon, MotionButton, closeButtonVariantProps } from './CloseButton.styled';
/**
 * @public
 */
export const CloseButton = ({
  animate = true,
  bgColor,
  boxShadowSize,
  className,
  color,
  onClick,
  size = 'md',
  title = 'close',
  variant,
  as,
  ...props
}) => {
  const [hover, setHover] = useState(false);
  return React.createElement(Relative, null, React.createElement(MotionButton, {
    bgColor: bgColor,
    boxShadowSize: boxShadowSize,
    className: className,
    color: color,
    onHoverEnd: () => setHover(false),
    onHoverStart: () => setHover(true),
    variant: variant,
    size: size,
    onClick: onClick,
    title: title,
    ...closeButtonVariantProps[variant],
    ...props
  }, animate && variant !== 'filled' && React.createElement(BackgroundAnimation, {
    initial: {
      scale: 0
    },
    animate: hover ? {
      scale: 1
    } : {
      scale: 0
    }
  }), React.createElement(CloseIcon, {
    size: size
  })));
};